function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

let cartMutationQueue = Promise.resolve();
Shopify.cartMutationRevision = 0;

Shopify.queueCartMutation = function(task) {
    const operation = cartMutationQueue.then(() => {
        Shopify.cartMutationRevision += 1;
        return task();
    });
    cartMutationQueue = operation.catch(() => {});
    return operation;
}

Shopify.whenCartChangesComplete = async function() {
    let pending;
    do {
        await Shopify.flushCartQuantities();
        pending = cartMutationQueue;
        await pending;
    } while (pending !== cartMutationQueue || cartQuantityIntents.size);
    if (Shopify.cartSyncFailed) throw new Error(window.cartStrings.error);
}

Shopify.changeItem = function(lineKey, quantity, index, callback) {
    return getCartUpdate(lineKey, quantity, callback);
}

Shopify.removeItem = function(lineKey, index, callback) {
    return getCartUpdate(lineKey, 0, callback);
}

const cartQuantityIntents = new Map();
const cartRemovalRows = new Map();
const cartEmptyContents = new WeakMap();
let cartDisplayItems;
let cartQuantityTimer;
let cartQuantityRun;
let lastCartNotification;
Shopify.cartQuantityRevision = 0;

function cartLineIdentity(variant, properties, plan) {
    const pairs = Array.isArray(properties) ? properties : Object.entries(properties || {});
    return JSON.stringify([String(variant), pairs.filter(pair => pair[1] !== '').sort((a, b) => String(a[0]).localeCompare(String(b[0]))), String(plan || '')]);
}

function cartRowIdentity(row) {
    if (!row?.dataset.cartVariant) return null;
    try { return cartLineIdentity(row.dataset.cartVariant, JSON.parse(row.dataset.cartProperties || '{}'), row.dataset.cartPlan); }
    catch (_) { return null; }
}

function cartInputIntent(input) {
    const identity = cartRowIdentity(input.closest('[data-item-row]'));
    const intents = [...cartQuantityIntents.values()];
    return intents.find(intent => intent.key === input.dataset.line || intent.keys.includes(input.dataset.line)) ||
        intents.find(intent => identity && intent.identity === identity && intents.filter(other => other.identity === identity).length === 1 &&
            new Set([...document.querySelectorAll('[data-cart-quantity]')].filter(other => cartRowIdentity(other.closest('[data-item-row]')) === identity).map(other => other.dataset.line)).size === 1);
}

Shopify.projectCartPrices = function() {
    const intents = [...cartQuantityIntents.values()];
    for (const state of document.querySelectorAll('[data-cart-price-state]')) {
        const root = state.closest('#main-cart-items, .previewCart-wrapper');
        if (!root) continue;
        let data;
        try { data = JSON.parse(state.dataset.cartPriceState); } catch (_) { continue; }
        const money = cents => Shopify.formatMoney(Math.round(cents), window.money_format);
        const write = (element, cents) => {
            if (!element) return;
            const value = (cents < 0 ? '-' : '') + money(Math.abs(cents));
            if (element.innerHTML !== value) element.innerHTML = value;
        };
        let original = data.original, total = data.total, eligible = 0, discountable = 0, changed = false;
        const discounts = new Map();
        const fixedDiscounts = new Map();
        for (const item of data.items) {
            const intent = intents.find(intent => intent.key === item.key || intent.keys.includes(item.key));
            const quantity = intent ? intent.quantity : item.quantity;
            const delta = quantity - item.quantity;
            const allocated = item.discounts.reduce((sum, discount) => sum + discount.amount, 0);
            original += delta * item.original;
            total += delta * (item.original - allocated / item.quantity);
            if (item.eligible) eligible += quantity * item.original;
            if (item.discountable) discountable += quantity * item.final;
            changed = changed || delta !== 0;
            for (const discount of item.discounts) {
                const projected = discount.amount * quantity / item.quantity;
                discounts.set(discount.title, (discounts.get(discount.title) || 0) + projected);
                if (discount.valueType === 'fixed_amount' && discount.allocation === 'across') {
                    const key = JSON.stringify([discount.type, discount.title, discount.value]);
                    const record = fixedDiscounts.get(key) || { title: discount.title, value: Math.round(Number(discount.value) * 100), projected: 0, capacity: 0 };
                    record.projected += projected;
                    record.capacity += quantity * item.original;
                    fixedDiscounts.set(key, record);
                }
            }
            const rows = [...root.querySelectorAll('[data-item-row]')].filter(row => {
                const key = row.dataset.line || row.dataset.onlineBufferKey;
                return key === item.key || intent?.keys.includes(key);
            });
            for (const row of rows) row.querySelectorAll('[data-item-price-with-quantity-display]').forEach(element => write(element, item.final * quantity));
        }
        for (const discount of fixedDiscounts.values()) {
            if (!changed || !Number.isFinite(discount.value)) continue;
            const amount = Math.min(discount.value, discount.capacity);
            total += discount.projected - amount;
            discounts.set(discount.title, (discounts.get(discount.title) || 0) - discount.projected + amount);
        }
        const page = root.id === 'main-cart-items';
        const estimate = page && (data.nonRewardDiscount ?? data.discount) === 0 && eligible >= data.minimum ? Math.floor(discountable * data.percent / 100) : 0;
        total = Math.max(0, Math.round(total) - estimate);
        const rewardProjection = window.BeadBucks?.project({ root, total, data, discounts, intents });
        if (rewardProjection) total = rewardProjection.total;
        const subtotal = root.querySelector('[data-cart-subtotal]');
        write(page ? subtotal?.querySelector('.cart-total-value .text') : subtotal, original);
        root.querySelectorAll('[data-cart-total-value]').forEach(element => {
            element.dataset.cartTotalValue = total;
            write(element.querySelector('.text') || element, total);
        });
        root.querySelectorAll('[data-cart-discount-amount]').forEach(element => {
            const amount = discounts.get(element.dataset.cartDiscountAmount) || 0;
            write(element, -amount);
            const row = element.closest('.total-price2_1, [data-cart-discount-row]');
            if (row) row.style.display = amount > 0 ? 'flex' : 'none';
        });
        const saved = root.querySelector('[data-cart-savings-amount]');
        const visibleDiscount = [...discounts.values()].reduce((sum, amount) => sum + amount, 0);
        write(saved, -Math.round(visibleDiscount));
        const savingsRow = root.querySelector('[data-saved-discount-display]');
        if (savingsRow) savingsRow.style.display = visibleDiscount > 0 ? '' : 'none';
        const warning = root.querySelector('[data-cart-wholesale-warning]');
        if (warning) {
            warning.style.display = eligible < data.minimum ? '' : 'none';
            const initial = data.minimum === 50000 && !(data.wholesale && eligible < 25000);
            warning.querySelector('[data-cart-wholesale-initial]').style.display = initial ? '' : 'none';
            warning.querySelector('[data-cart-wholesale-minimum]').textContent = initial ? '$500 minimum' : '$250 minimum';
        }
        const region = root.querySelector('[data-cart-manual-discount]');
        if (region) {
            if (estimate > 0 && !region.firstElementChild) region.replaceChildren(root.querySelector('[data-cart-manual-template]').content.cloneNode(true));
            region.style.display = estimate > 0 ? '' : 'none';
            write(region.querySelector('[data-cart-manual-amount]'), -estimate);
        }
        root.querySelectorAll('[data-cart-price-pending]').forEach(element => { element.hidden = !(changed || rewardProjection?.estimated); element.style.display = changed || rewardProjection?.estimated ? '' : 'none'; });
        if (window.Currency?.convertAll && window.Currency.currentCurrency && window.Currency.currentCurrency !== window.shop_currency) window.Currency.convertAll(window.shop_currency, window.Currency.currentCurrency, 'span.money', 'money_format');
    }
};

Shopify.setCartEmpty = function(root, empty) {
    if (!root) return;
    let view = root.querySelector(':scope > [data-cart-empty-update]');
    if (!empty) {
        view?.remove();
        for (const [child, previous] of cartEmptyContents.get(root) || []) {
            if (!child.isConnected) continue;
            child.hidden = false;
            if (previous.display) child.style.setProperty('display', previous.display, previous.priority);
            else child.style.removeProperty('display');
        }
        cartEmptyContents.delete(root);
        return;
    }
    const template = root.querySelector(':scope > [data-cart-empty-template]');
    if (!template) return;
    if (!cartEmptyContents.has(root)) cartEmptyContents.set(root, new Map());
    const contents = cartEmptyContents.get(root);
    for (const child of root.children) {
        if (child === view || child.hidden || ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK'].includes(child.tagName)) continue;
        if (!contents.has(child)) contents.set(child, { display: child.style.getPropertyValue('display'), priority: child.style.getPropertyPriority('display') });
        child.hidden = true;
        child.style.setProperty('display', 'none', 'important');
    }
    if (!view) {
        view = document.createElement('div');
        view.setAttribute('data-cart-empty-update', '');
        view.append(template.content.cloneNode(true));
        root.append(view);
    }
};

Shopify.projectCartState = function() {
    let items = cartDisplayItems;
    if (!items) {
        try { items = JSON.parse(document.querySelector('[data-cart-price-state]')?.dataset.cartPriceState).items; }
        catch (_) { return; }
    }
    const intents = [...cartQuantityIntents.values()];
    const count = items.reduce((sum, item) => {
        const intent = intents.find(intent => intent.key === item.key || intent.keys.includes(item.key));
        return sum + (intent ? intent.quantity : item.quantity);
    }, 0);
    document.querySelectorAll('[data-cart-count]').forEach(element => {
        element.textContent = count >= 100 && element.closest('.cart-count-bubble') ? window.cartStrings.item_99 : count;
    });
    document.querySelectorAll('[data-cart-text]').forEach(element => { element.textContent = count === 1 ? window.cartStrings.item : window.cartStrings.items; });
    document.querySelectorAll('#main-cart-items, #halo-cart-sidebar .previewCart-wrapper').forEach(root => Shopify.setCartEmpty(root, count === 0));
};

Shopify.syncCartQuantities = function() {
    const removals = new Map();
    document.querySelectorAll('[data-cart-quantity]').forEach(input => {
        const intent = cartInputIntent(input);
        if (intent) input.value = intent.quantity;
        const row = input.closest('[data-item-row]');
        if (row && intent?.quantity === 0) removals.set(row, intent);
    });
    for (const [row, previous] of cartRemovalRows) {
        if (removals.has(row)) continue;
        if (row.isConnected) {
            if (previous.confirmed) row.remove();
            else {
                if (previous.hidden === null) row.removeAttribute('hidden');
                else row.setAttribute('hidden', previous.hidden);
                if (previous.display) row.style.setProperty('display', previous.display, previous.priority);
                else row.style.removeProperty('display');
            }
        }
        cartRemovalRows.delete(row);
    }
    for (const [row, intent] of removals) {
        if (!cartRemovalRows.has(row)) cartRemovalRows.set(row, {
            hidden: row.getAttribute('hidden'),
            display: row.style.getPropertyValue('display'),
            priority: row.style.getPropertyPriority('display')
        });
        cartRemovalRows.get(row).confirmed = intent.missing && intent.confirmed === 0;
        row.hidden = true;
        row.style.setProperty('display', 'none', 'important');
    }
    const busy = cartQuantityIntents.size > 0;
    document.querySelectorAll('#main-cart-items, #halo-cart-sidebar .previewCart-wrapper').forEach(element => element.setAttribute('aria-busy', String(busy)));
    document.querySelectorAll('[data-cart-express]').forEach(element => { element.inert = busy; });
    Shopify.projectCartPrices();
    Shopify.projectCartState();
}

Shopify.acceptCart = function(cart) {
    cartDisplayItems = cart.items;
    const previousKeys = new Set([...document.querySelectorAll('[data-item-row]')].map(row => row.dataset.line || row.dataset.onlineBufferKey));
    for (const intent of cartQuantityIntents.values()) {
        const candidates = cart.items.filter(item => !previousKeys.has(item.key) && intent.identity && cartLineIdentity(item.variant_id, item.properties, item.selling_plan_allocation?.selling_plan?.id) === intent.identity &&
            ![...cartQuantityIntents.values()].some(other => other !== intent && other.key === item.key));
        const item = cart.items.find(item => item.key === intent.key) || (candidates.length === 1 ? candidates[0] : null);
        intent.confirmed = item ? item.quantity : 0;
        if (item) { intent.key = item.key; if (!intent.keys.includes(item.key)) intent.keys.push(item.key); }
        intent.missing = !item;
    }
}

Shopify.notifyCart = function(cart) {
    Shopify.acceptCart(cart);
    if (lastCartNotification === cart) return;
    lastCartNotification = cart;
    document.querySelectorAll('[data-cart-text]').forEach(element => { element.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items; });
    const status = document.getElementById('cart-live-region-text');
    if (status) status.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items);
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
}

Shopify.requestCartQuantity = function(key, quantity, input) {
    quantity = Number(quantity);
    if (!Number.isInteger(quantity) || quantity < 0) {
        if (input) input.value = input.defaultValue;
        showWarning(window.cartStrings.error);
        return;
    }
    input = input || [...document.querySelectorAll('[data-cart-quantity]')].find(element => element.dataset.line === key);
    const row = input?.closest('[data-item-row]');
    const identity = cartRowIdentity(row);
    let intent = input && cartInputIntent(input);
    if (!intent) {
        intent = { key, keys: [key], identity, quantity, confirmed: Number(input?.defaultValue || 0), revision: 0 };
        cartQuantityIntents.set(key, intent);
    }
    const max = Number(row?.dataset.onlineBufferMax ?? row?.dataset.onlineBufferEffective);
    if (['1', 'true'].includes(row?.dataset.onlineBufferApplies) && Number.isFinite(max)) quantity = Math.min(quantity, Math.max(0, max));
    const policy = row?.dataset.cartPolicy || window['cart_selling_array_' + input?.dataset.product]?.[input?.dataset.cartQuantityId];
    const stock = Number(input?.dataset.inventoryQuantity);
    if (policy === 'deny' && Number.isFinite(stock)) quantity = Math.min(quantity, Math.max(0, stock));
    if (quantity < Number(arguments[1])) showWarning(getInputMessage(quantity), warningTime);
    intent.quantity = quantity;
    intent.revision += 1;
    Shopify.cartQuantityRevision += 1;
    Shopify.syncCartQuantities();
    clearTimeout(cartQuantityTimer);
    cartQuantityTimer = setTimeout(() => { Shopify.flushCartQuantities(); }, 160);
}

Shopify.flushCartQuantities = function() {
    clearTimeout(cartQuantityTimer);
    if (cartQuantityRun) return cartQuantityRun;
    cartQuantityRun = (async () => {
        let latestCart;
        while (cartQuantityIntents.size) {
            const intent = [...cartQuantityIntents.values()].find(intent => intent.quantity !== intent.confirmed && !intent.missing);
            if (intent) {
                const revision = intent.revision;
                const cart = await Shopify.changeItem(intent.key, intent.quantity, null, cart => {
                    Shopify.acceptCart(cart);
                    if (intent.revision === revision) intent.quantity = intent.confirmed;
                });
                if (cart) latestCart = cart;
                else { latestCart = null; intent.quantity = intent.confirmed; }
                Shopify.syncCartQuantities();
                continue;
            }
            const revision = Shopify.cartQuantityRevision;
            if (latestCart) await window.refreshOnlineBufferCart(latestCart);
            if (revision !== Shopify.cartQuantityRevision) continue;
            cartQuantityIntents.clear();
            Shopify.syncCartQuantities();
        }
    })().catch(error => {
        Shopify.cartSyncFailed = true;
        cartQuantityIntents.clear();
        showWarning(window.cartStrings.error);
    }).finally(() => { cartQuantityRun = null; Shopify.syncCartQuantities(); });
    return cartQuantityRun;
}

function syncCartAttributes(current, next) {
    for (const attribute of [...current.attributes]) if (!next.hasAttribute(attribute.name)) current.removeAttribute(attribute.name);
    for (const attribute of next.attributes) if (current.getAttribute(attribute.name) !== attribute.value) current.setAttribute(attribute.name, attribute.value);
}

function patchCartRegion(current, next, selector) {
    const targets = current.querySelectorAll(selector);
    next.querySelectorAll(selector).forEach((source, index) => {
        const target = targets[index];
        if (!target) return;
        syncCartAttributes(target, source);
        if (target.innerHTML !== source.innerHTML) target.innerHTML = source.innerHTML;
    });
}

Shopify.patchCartRows = function(current, next) {
    const list = current.querySelector('.cart-list, .previewCartList');
    const nextList = next.querySelector('.cart-list, .previewCartList');
    if (!list || !nextList) return false;
    const oldRows = [...list.querySelectorAll('[data-item-row]')];
    const nextRows = [...nextList.querySelectorAll('[data-item-row]')];
    const nextKeys = new Set(nextRows.map(row => row.dataset.line || row.dataset.onlineBufferKey));
    const retained = new Set();
    const focused = document.activeElement;
    let anchor = list.firstElementChild;
    for (const source of nextRows) {
        const key = source.dataset.line || source.dataset.onlineBufferKey;
        const identity = cartRowIdentity(source);
        const candidates = oldRows.filter(row => !retained.has(row) && !nextKeys.has(row.dataset.line || row.dataset.onlineBufferKey) && identity && cartRowIdentity(row) === identity);
        const target = oldRows.find(row => !retained.has(row) && (row.dataset.line || row.dataset.onlineBufferKey) === key) || (candidates.length === 1 ? candidates[0] : null);
        if (!target) {
            list.insertBefore(source, anchor);
            anchor = source.nextElementSibling;
            continue;
        }
        retained.add(target);
        if (target !== anchor) list.insertBefore(target, anchor);
        anchor = target.nextElementSibling;
        syncCartAttributes(target, source);
        patchCartRegion(target, source, '.cart-item-price, .cart-item-total, .cart-item-total__2, .cart-item-total__3, .previewCartItem-price, [data-cart-line-discounts]');
        for (const selector of ['cart-update-quantity', '[data-cart-quantity]', '[data-cart-remove]', '[data-open-edit-cart]']) {
            const oldElements = target.querySelectorAll(selector);
            source.querySelectorAll(selector).forEach((element, index) => {
                const old = oldElements[index];
                if (!old) return;
                syncCartAttributes(old, element);
                if (old.matches('[data-cart-quantity]')) old.value = element.value;
                if (window.jQuery) window.jQuery(old).removeData('line').removeData('index').removeData('edit-cart-quantity');
            });
        }
    }
    oldRows.filter(row => !retained.has(row)).forEach(row => row.remove());
    if (focused?.isConnected && document.activeElement !== focused) focused.focus({ preventScroll: true });
    Shopify.syncCartQuantities();
    return true;
}

Shopify.patchCartSummary = function(current, next) {
    patchCartRegion(current, next, '[data-cart-subtotal], .cart-total-grandtotal, .cart-total-savings, .previewCartTotalsPrice');
    const oldExpress = current.querySelector('[data-cart-express]');
    const newExpress = next.querySelector('[data-cart-express]');
    if (oldExpress && newExpress && oldExpress.dataset.membership !== newExpress.dataset.membership) {
        syncCartAttributes(oldExpress, newExpress);
        oldExpress.replaceChildren(...newExpress.childNodes);
    }
    Shopify.syncCartQuantities();
}

document.addEventListener('cart-update', event => {
    if (isCartChangeResponse(event.detail)) Shopify.acceptCart(event.detail);
});

function isCartChangeResponse(cart) {
    return cart && Array.isArray(cart.items) && Number.isInteger(cart.item_count) && cart.item_count >= 0 &&
        Number.isFinite(cart.total_price) && cart.items.every(item => item && typeof item.key === 'string' &&
            Number.isInteger(item.quantity) && item.quantity >= 0);
}

function getCartUpdate(lineKey, quantity, callback) {
    return Shopify.queueCartMutation(async () => {
        try {
            if (typeof lineKey !== 'string' || !lineKey.includes(':') || !Number.isInteger(Number(quantity)) || Number(quantity) < 0) {
                throw new Error(window.cartStrings.error);
            }
            await window.VibeadMembership.checkChange(lineKey, quantity);
            const body = JSON.stringify({
                id: lineKey,
                quantity: Number(quantity),
                sections_url: window.location.pathname,
            });
            const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body });
            const cart = await response.json().catch(() => null);
            if (!response.ok || !isCartChangeResponse(cart) || cart.errors) {
                throw new Error(typeof cart?.description === 'string' ? cart.description : typeof cart?.errors === 'string' ? cart.errors : window.cartStrings.error);
            }
            Shopify.cartSyncFailed = false;
            if (typeof callback === 'function') {
                await callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
            return cart;
        } catch (error) {
            const message = error.message || window.cartStrings.error;
            if (error.membershipCode) window.VibeadMembership.report(error);
            else showWarning(String(message).replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]));
            Shopify.cartSyncFailed = true;
            try {
                const response = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
                const cart = await response.json().catch(() => null);
                if (!response.ok || !isCartChangeResponse(cart)) return null;
                Shopify.acceptCart(cart);
                Shopify.cartSyncFailed = false;
                if (typeof window.refreshOnlineBufferCart === 'function') {
                    await window.refreshOnlineBufferCart(cart);
                } else {
                    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
                }
            } catch (_) {}
            return null;
        }
    });
}

Shopify.addItem = function(variant_id, quantity, $target, callback, input = null) {
    var quantity = quantity || 1;
    const dataForm = new URLSearchParams({ quantity: String(quantity), id: String(variant_id) });

    if ($target.closest('form')) {
        const $thisForm = $target.closest('form');
        const $properties = $thisForm.find('[name^="properties"]');
        if ($properties.length) $properties.each((index, element) => { dataForm.append($(element).attr('name'), String($(element).val())); });
    }

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: dataForm.toString(),
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            var message = window.cartStrings.addProductOutQuantity2;
            if (input && input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            } 
            
            try {
                Shopify.onError(XMLHttpRequest, textStatus, message);
            } finally {
                $target.removeClass('is-loading');
            }
        }
    };
    return window.VibeadMembership.add([{ id: variant_id, quantity }], () => new Promise((resolve, reject) => {
        $.ajax({ ...params,
            success: item => { try { params.success(item); resolve(item); } catch (error) { reject(error); } },
            error: (xhr, status) => { params.error(xhr, status); reject(new Error(window.cartStrings.error)); }
        });
    })).catch(error => {
        if (error.membershipCode) window.VibeadMembership.report(error);
        $target.removeClass('is-loading');
        document.querySelector('.background-overlay')?.classList.remove('hold');
    });
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = {};
    try {
        const parsed = JSON.parse(XMLHttpRequest.responseText);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) data = parsed;
    } catch (_) {}
    if (!!data.message) {
        !!data.description ? showWarning(data.description) : showWarning(data.message + ': ' + message, warningTime);
    } else {
        showWarning('Error : ' + message, warningTime);
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeCart = false;
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        const $target = event.currentTarget
        let el_input = $target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = $target.closest('.product-form')?.querySelector('[data-btn-addtocart]');
        let newVal, checkAvailabel = false;

        const policyArray = document.body.matches('.quickshop-popup-show') ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`],
            currentId = document.body.matches('.quickshop-popup-show') ? this.closest('.productView-options').querySelector('[name="id"]').value : this.input.dataset.cartQuantityId,
            thisVariantStatus = this.input.closest('[data-item-row]')?.dataset.cartPolicy || policyArray?.[currentId];

        buttonAdd?.dataset.available == 'false' || buttonAdd?.dataset.available == undefined ? checkAvailabel = true : checkAvailabel = false;

        if ($target.matches('.plus')) newVal = value + 1;
        else if ($target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal < 0 ) newVal = 1;

        if (newVal > inStockNumber && checkAvailabel && thisVariantStatus == 'deny') {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }

        el_input.value = newVal;
        if (el_input.matches('[data-cart-quantity]') && !el_input.closest('.quick-order-list__contents')) {
            Shopify.requestCartQuantity(el_input.dataset.line, newVal, el_input);
            return;
        }

        if (typeof this.changeCart  == 'number') {clearTimeout(this.changeCart)};
        this.changeCart = setTimeout(() => {if ($target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent)}, 350);
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray == undefined ? false : sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue'
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }
    
    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

        if (newVal > inStockNumber && !buttonAdd.matches('.button--pre-untrack')) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }
        
        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
    }
}

class ProductScroller extends HTMLElement {
    constructor() {
        super();    
        this.container = this.querySelector('[data-drag-container]');
        this.dragParent = this.querySelector('[data-drag-parent]');

        this.initDragToScroll();
    }

    initDragToScroll() {
        const isOverflowing = (wrapper) => {
            return wrapper.clientWidth < wrapper.scrollWidth
        }
        let containerOverflowing = isOverflowing(this.container)

        if (containerOverflowing) {
            this.dragToScroll(this.container)
            return 
        }
        this.dragToScroll(this.dragParent)
    }   
    
    dragToScroll(slider) {
        let mouseDown = false;
        let start;
        let scrollLeft;
        let inactiveTimeout;

        slider.addEventListener('mousedown', (e) => {
            const target = e.target 

            mouseDown = true;
            start = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseup', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });

        slider.addEventListener('mousemove', (e) => {
            if(!mouseDown) return;
            e.preventDefault();

            if (!slider.classList.contains('active')) {
                slider.classList.add('active');
            }

            const x = e.pageX - slider.offsetLeft;
            const walk = (x - start) * 1; 
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.addEventListener('mouseleave', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super() 

        this.imageContainer = this; 
        this.initObserver();
    }   

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        }, 
        {
            threshold: 0.4 
        });
        
        this.observer.observe(this.imageContainer);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    customElements.define('product-scroller', ProductScroller);
    // customElements.define('image-to-flip', ImageToFlip);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options); 
        this.observer.observe(this);
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
    this.loadScrolling();
})

window.onscroll = () => {this.loadScrolling()};

function loadScrolling() {
    document.querySelectorAll('[data-scrolling]').forEach(element => {element.dataset.scrolling == 'vertical' ? this.scrollVertical(element) : this.scrollHorizontal(element)})
}

function scrollVertical(element) {
    const $thisItem = element.closest('.special-banner__item') || element,
        top = $thisItem.getBoundingClientRect().top,
        height = $thisItem.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        coefficient = element.scrollHeight/height,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2;

    if (top - redundant < 0 && top > height*-1) this.scrollTop(element, (top*-1 + redundant)*coefficient)
    else if (top - redundant >= 0) this.scrollTop(element, 0)
    else this.scrollTop(element, element.scrollHeight)
}

function scrollTop(element, scope) {
    element.scrollTo({top: scope, behavior: "smooth"})
}

function scrollHorizontal(element) {
    const $thisFirst = element.querySelector('.scrolling-text__list--1'),
        $thisSecond = element.querySelector('.scrolling-text__list--2');

    if (!$thisFirst) return;
  
    const top = element.getBoundingClientRect().top,
        height = element.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        scrollWidth = $thisFirst.scrollWidth > window.innerWidth ? $thisFirst.scrollWidth - window.innerWidth : 0,
        contentHeight = $thisFirst.getBoundingClientRect().height*2,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2,
        coefficient = scrollWidth/(height/2 + redundant - contentHeight);
    
    let scope = (top*-1 + redundant)*coefficient,
        scope2 = (height/2 - contentHeight + redundant)*coefficient - scope;
    
    if (top - redundant < 0 && top - contentHeight > height*-1/2) {scope = scope*-1; scope2 = scope2*-1}
    else if (top - redundant >= 0) {scope = 0; scope2 = scrollWidth*-1}
    else {scope = scrollWidth*-1; scope2 = 0}
    $thisFirst.scrollWidth <= window.innerWidth ? $thisSecond.style.justifyContent = 'flex-end' : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
    $thisFirst.style.transform = `translateX(${scope}px)`;
    $thisSecond.style.transform = `translateX(${(scope2)}px)`;
}

class SmoothScrollMenu {
    constructor(selector) {
        this.menuItems = document.querySelectorAll(selector);
        this.attachEvents();
        this.hideMenuItemsWithoutSection();
    }

    attachEvents() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== "#") {
                anchor.addEventListener('click', event => this.handleMenuItemClick(event, anchor));
            }
        });
    }

    handleMenuItemClick(event, anchor) {
        event.preventDefault();

        var targetHref = anchor.getAttribute('href');
        var shouldScroll = true;
        const location = window.location.pathname + window.location.hash;

        if (targetHref.includes('/') && location !== targetHref) {
            window.location.href = targetHref;
            shouldScroll = false;
        }

        if (shouldScroll) {
            var targetElement = document.getElementById(anchor.getAttribute('href').split('#')[1]);
            if (targetElement) {
                this.scrollToSection(targetElement);
            }
        }
    }

    scrollToSection(element) {
        this.smoothScrollTo(element);
    }

    smoothScrollTo(element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop
        });
    }

    hideMenuItemsWithoutSection() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            const hash = anchor.getAttribute('href').split('#')[1];
            if (hash !== undefined && hash !== '' && !document.getElementById(hash)) {
                item.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new SmoothScrollMenu('.header__inline-menu .menu-lv-1');
    customElements.define('details-disclosure', DetailsDisclosure);
});

class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp);
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.focus();
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open')
    }
}

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class PositiveVibesComponent extends HTMLElement {
    constructor() {
        super();
        this.productPositiveVibes();
    }

    productPositiveVibes() {
        const parent = this.querySelector('.text-vibes');
        const children = this.querySelectorAll('.text-vibes--child');
        let currentIndex = 0;

        if (children.length > 1) {
            const newDiv = document.createElement("div");
            newDiv.classList.add("text-vibes--child");
            newDiv.innerHTML = children[0].innerHTML;
            parent.appendChild(newDiv);
            
            const childrens = parent.querySelectorAll('.text-vibes--child');
            setInterval(() => {
                const height = childrens[currentIndex].offsetHeight;
                childrens.forEach((child, index) => {
                    parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
                    if (currentIndex == 0) {
                        parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
                    }
                });
                currentIndex = (currentIndex + 1) % childrens.length;
                this.heightPositive();
            }, 3000);
        }
    }

    heightPositive() {
        const parent = this.querySelector('.text-vibes');
        const childrens = this.querySelectorAll('.text-vibes--child');
        
        let maxHeight = 0;
        childrens.forEach(child => {
            maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
        });

        this.style.minHeight = maxHeight + 'px';

        childrens.forEach(child => {
            child.style.minHeight = `${maxHeight}px`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    customElements.define('positive-vibes', PositiveVibesComponent);
})

function checkTransparentHeader() {
    allowTransparent();

    if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", allowTransparent);
        document.addEventListener("shopify:section:unload", allowTransparent);
        document.addEventListener("shopify:section:reorder", allowTransparent);
    }
}

function allowTransparent() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
        return;
    } else {
        document.querySelector("body").removeAttribute("allow-transparency");
    }
}

document.addEventListener('DOMContentLoaded', function () {
    checkTransparentHeader();
});

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = false;
        this.ids = [];
    }

    startQueue(id, quantity) {
        this.queue.push({ id, quantity });
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue);
                }
            } else {
                clearInterval(interval);
            }
        }, 250);
    }

    sendRequest(queue) {
        this.requestStarted = true;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity;
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items);
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`[data-quantity-variant-id="${id}"]`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;

        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue);
        }
    }

    getSectionsUrl(sectionId) {
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        if (sectionId) url.searchParams.set('section_id', sectionId);
        return url.pathname + url.search;
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
}

class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
  
      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener('input', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this))
      }
    }
  
    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a')
    }
  
    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
      }
    }
  }
  customElements.define('search-form', SearchForm);

(() => {
    const observedHeaders = new WeakSet();
    const observeHeaderCounts = () => {
        document.querySelectorAll('.header-single-line, .header-mobile').forEach(header => {
            if (observedHeaders.has(header)) return;
            observedHeaders.add(header);

            const syncBadges = () => {
                header.querySelectorAll('.cart-count-bubble, .wishlist-count-bubble').forEach(badge => {
                    const counter = badge.querySelector('[data-cart-count], .iwish-counter, [data-wishlist-count]');
                    if (counter) badge.hidden = !(Number.parseInt(counter.textContent.trim(), 10) > 0);
                });
            };

            syncBadges();
            new MutationObserver(syncBadges).observe(header, {
                childList: true,
                characterData: true,
                subtree: true
            });
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeHeaderCounts, { once: true });
    } else {
        observeHeaderCounts();
    }
    document.addEventListener('shopify:section:load', observeHeaderCounts);
})();
